import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export enum DisplayType {
    MOBILE,
    DESKTOP,
    TABLET
}

export interface DisplayState {
    type: DisplayType
    displayWidth: number;
    scrollYEnabled: boolean;
    globalLoading: boolean;
}

const initialState: DisplayState = {
    type: DisplayType.MOBILE,
    displayWidth: window.innerWidth,
    scrollYEnabled: true,
    globalLoading: false
}

function handleWindowResizeEvent(width: number, state: DisplayState) {
    if (width <= 768) {
        state.type = DisplayType.MOBILE
    } else {
        state.type = DisplayType.DESKTOP
    }
    state.displayWidth = width
    return;
}

export const displaySlice = createSlice({
    name: 'display',
    initialState,
    reducers: {
        setWindowWidth: (state, action: PayloadAction<number>) => {
            handleWindowResizeEvent(action.payload, state)
        },
        changeScrollEnabled: (state, action: PayloadAction<boolean>) => {
            state.scrollYEnabled = action.payload
        },
        setGlobalLoadingState: (state, action: PayloadAction<boolean>) => {
            state.globalLoading = action.payload
        }
    }
})

export const { setWindowWidth, changeScrollEnabled, setGlobalLoadingState } = displaySlice.actions;

export default displaySlice.reducer;